/** Whether a pivot value filter's number counts members or is a percentage of them. */
export enum PivotValueFilterModeEnum {
  items = 'items',
  percent = 'percent',
}
